module.exports = __webpack_public_path__ + "static/img/71.7b3876c.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/img_left_icon/71.png
// module id = 0LhC
// module chunks = 1